import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';
import { boat_details } from './boats.schema';

export const alerts = sqliteTable('alerts', {
  id: text('id').notNull().primaryKey(),
  // Already selected by the alerts sync stream (`id AS laravel_id`). Declared here so it is
  // kept locally rather than dropped: it is the id the REST and GraphQL APIs address an alert
  // by, which a row synced under its uuid otherwise has no way to name.
  laravel_id: integer('laravel_id'),
  title: text('title'),
  type: text('type'),
  date: text('date'),
  status: text('status'),
  priority: integer('priority'),
  active: integer('active'),
  alertable_id: integer('alertable_id'),
  alertable_type: text('alertable_type'),
  is_pre_alert: integer('is_pre_alert'),
  category: text('category'),
  boat_detail_id: integer('boat_detail_id'),
  boat_detail_uuid: text('boat_detail_uuid').references(() => boat_details.id),
  organization_id: text('organization_id'),
  created_at: text('created_at'),
  marked_as_done_at: text('marked_as_done_at'),
  quantity: integer('quantity'),
  threshold: integer('threshold'),
});

// laravel_id: column.integer,
//     title: column.text,
//     type: column.text,
//     date: column.text,
//     status: column.text,
//     priority: column.integer,
//     active: column.integer,
//     alertable_id: column.integer,
//     alertable_type: column.text,
//     is_pre_alert: column.integer,
//     category: column.text,
//     created_at: column.text
